var _mask, _path, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_8663_25337",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0C0.895431 0 0 0.89543 0 2V12C0 13.1046 0.89543 14 2 14H3.00018L3.00007 16.9993L8.62363 14H16C17.1046 14 18 13.1046 18 12V2C18 0.895431 17.1046 0 16 0H2Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00018 14L4.00018 14L4.00022 13H3.00018V14ZM3.00007 16.9993L2.00007 16.9993L2 18.6661L3.47067 17.8817L3.00007 16.9993ZM8.62363 14V13H8.37362L8.15303 13.1177L8.62363 14ZM1 2C1 1.44772 1.44772 1 2 1V-1C0.343146 -1 -1 0.343146 -1 2H1ZM1 12V2H-1V12H1ZM2 13C1.44772 13 1 12.5523 1 12H-1C-1 13.6569 0.343146 15 2 15V13ZM3.00018 13H2V15H3.00018V13ZM4.00007 16.9994L4.00018 14L2.00018 14L2.00007 16.9993L4.00007 16.9994ZM8.15303 13.1177L2.52947 16.117L3.47067 17.8817L9.09423 14.8823L8.15303 13.1177ZM16 13H8.62363V15H16V13ZM17 12C17 12.5523 16.5523 13 16 13V15C17.6569 15 19 13.6569 19 12H17ZM17 2V12H19V2H17ZM16 1C16.5523 1 17 1.44772 17 2H19C19 0.343146 17.6569 -1 16 -1V1ZM2 1H16V-1H2V1Z",
    fill: "currentColor",
    mask: "url(#path-1-inside-1_8663_25337)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5,
    width: 12,
    height: 1,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 8,
    width: 8,
    height: 1,
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.aa09731e415ce932ba2305d9613d7efb.svg";
export { ForwardRef as ReactComponent };